<template>
  <div class="course-box" @click="clickCourseItem">
    <img :src="item.image" alt="" class="course-banner" />

    <div class="course-info">
      <div class="course-title one-line">
        {{ item.name }}
      </div>
      <div class="course-intro two-line">
        {{ item.introduction }}
      </div>
      <div class="course-view">{{ item.read_num }}</div>
      <template
        v-if="
          item.video_count <= item.video_watched_count && item.video_count !== 0
        "
      >
        <div class="has-learned"></div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Course",
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["has_login"])
  },
  methods: {
    clickCourseItem() {
      const { item, has_login } = this;
      if (has_login) {
        const { id } = item;
        this.$router.push({
          name: "Video",
          query: {
            id
          }
        });
      } else {
        this.$bus.$emit("show-login-box");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
